export default __webpack_public_path__ + "static/media/0318_DSC7601.0eca5cd8.jpg";